/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import {
  Nav,
  Container,
  Row,
  Col,
  TabContent,
  TabPane,
  Fade,
} from 'reactstrap';
import classnames from 'classnames';
import {
  Link,
  Redirect,
  Route,
} from 'react-router-dom';

import AppComponent from './AppComponent';
import navData from '../../nav';

import '../../css/Dashboard.css';


class Dashboard extends AppComponent {
  isActiveTab = tab => this.props.location.pathname === tab;

  render() {
    if (this.app.user.facilities.length === 0) {
      return (<Redirect to="/adrift" />);
    }

    if (this.props.location.pathname === '/' || this.props.location.pathname === '') {
      return (<Redirect to={navData.paths.alerts} />);
    }

    return (
      <Container fluid id="main-container">
        <Row className="flex-xl-nowrap flex-fill">
          <Col lg={3} xl={2} className="flex-fill d-none d-lg-block">
            <Nav className="hotsheet-Dashboard-tabList flex-column" pills role="tablist" aria-orientation="vertical">
              {
                navData.navs.map(nav => (
                  <Link
                    key={nav.path}
                    className={classnames({ active: this.isActiveTab(nav.path) }, 'nav-link')}
                    to={nav.path}
                    role="tab"
                  >
                    <span className={nav.icon} /> {nav.label}
                  </Link>
                ))
              }
            </Nav>
          </Col>

          <Col md={12} lg={9} xl={10} className="flex-fill">
            <TabContent className="flex-fill" activeTab={this.props.location.pathname}>
              {
                navData.navs.map(nav => (
                  <TabPane
                    key={nav.path}
                    className="flex-fill overflow-y"
                    tabId={nav.path}
                    role="tabpanel"
                    aria-labelledby="v-pills-filters-tab"
                  >
                    <Fade in={this.isActiveTab(nav.path)}>
                      <Route path={nav.path} render={() => <nav.component facilityId={this.app.user.facilities[0].id} />} />
                    </Fade>
                  </TabPane>
                ))
              }
            </TabContent>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/core/Dashboard.js